import Crud from './crud'
var crud = new Crud('products', 'sản phẩm');

const state = {
    ...crud.state,
    selected: {
        id: 0,
        product_code: '',
        note: ''
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};